const SuperAdminFactory = ($http, $q, $log, NewBackendService, $rootScope, endPoints) => {
    'ngInject';

    const service = {
        getMerchantStore: () => $q((resolve, reject) => {


            $http.post(endPoints.superAdminUrl + `ListUsers`, {
                data: {
                    request: {
                        getMerchantStoreListRequest: {}
                    }
                }
            }, {
                customErrorManagement: true,
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(
                (response) => {
                    $rootScope.$broadcast('SUPER_ADMIN_LOGGED_IN');
                    resolve(response.data.response.getMerchantStoreListResponse);
                },
                (error) => {
                    $log.debug('errore lista merchant', error);
                    reject(error);
                });
        }),
    };

    return service;
};

export default SuperAdminFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/superAdmin.factory.js
 **/